export const REPO_NAME = 'Star-Wars-React';